export function formatDocument(taskId) {
    return (document) => {
        const { attachmentId: documentId } = document;
        return {
            document_id: documentId,
            task_id: taskId,
        };
    };
}
